import React, { useState } from "react";
import { FaCheck } from "react-icons/fa6";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

export default function Type_n_Select({
  title,
  reduxKey,
  value,
  onChange,
  optionsArray = [],
  condition,
  isArrayBig,
  inputType, // Default input type
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleOptionClick = (optionValue) => {
    onChange({ target: { value: optionValue } });
    setIsDropdownOpen(false);
  };

  const handleInputChange = (e) => {
    let inputValue = e.target.value;

    // Validate input based on inputType
    if (inputType === "Number") {
      // Allow only numbers
      if (!/^\d*$/.test(inputValue)) return;
    } else if (inputType === "String") {
      // Allow any string input (default behavior)
    } else if (inputType === "Decimal") {
      // Allow only decimal numbers
      if (!/^\d*\.?\d*$/.test(inputValue)) return;
    }
    onChange({ target: { value: Number(inputValue) } });
  };

  return (
    <div className="flex flex-col items-center justify-center w-full gap-2">
      <h1 className="text-m w-full px-2 text-gray-600 font-medium text-left">
        {title}
      </h1>
      <div className="relative px-2 flex flex-col items-center justify-center gap-1 w-full">
        <input
          type={
            inputType === "Number" || inputType === "Decimal" ? "text" : "text"
          }
          value={value}
          placeholder="Enter value..."
          className="border focus:outline-none w-full border-gray-300 rounded text-gray-500 px-2"
          onChange={handleInputChange}
        />
        <span
          className={`absolute top-1/2 transform -translate-y-1/2 right-4 cursor-pointer`}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          {isDropdownOpen ? (
            <MdKeyboardArrowUp className="text-gray-400" />
          ) : (
            <MdKeyboardArrowDown className="text-gray-400" />
          )}
        </span>
        {isDropdownOpen && (
          <ul
            className={`absolute top-full left-[3.4%] right-0 bg-white border rounded shadow-md mt-1 z-30 overflow-y-auto w-[93%] ${
              isArrayBig ? "h-[10.5rem]" : "h-auto"
            }`}
          >
            {optionsArray.map((option, index) => (
              <li
                key={index}
                className="px-2 py-1 cursor-pointer hover:bg-gray-100 w-full flex text-gray-500 justify-between items-center"
                onClick={() => handleOptionClick(option.value)}
              >
                {option.label}
                {option.value === value ? (
                  <FaCheck className="text-lg" />
                ) : null}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
